import styled from 'styled-components';
import React from "react";
const HexagonWrapper = styled.div`
  position: relative;
  width: 40px; 
  display:inline-block;
  margin:20px 10px;
  height: 23.09px;
  background-color: ${({ green, yellow,red,blue, white }) =>
    green ? "#22A122" : yellow ? "#eed94a" : blue ? "#42A5F5" : red ? "#f32643" : white ? '#ffffff' : "#E0E0E0"};
    
    /* green ? "#22A122" : blue ? "#42A5F5" : yellow ? "#eed94a" : red ? "#f32643" : white ? '#ffffff' : "#E0E0E0"};*/

  /* margin: 11.55px 0; */
  &:before,&:after {
    content: "";
    position: absolute;
    width: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
  }
  &:before {
    bottom: 100%;
    border-bottom: 11.55px solid ${({ green, yellow,red, white }) =>
    green ? "#42A5F5" : yellow ? "#eed94a" : red ? "#f32643" : white ? '#ffffff': "#E0E0E0"};
  }
  &:after {
    top: 100%;
    width: 0;
    border-top: 11.55px solid ${({ green, yellow,red,blue, white }) =>
    green ? "#22A122" : yellow ? "#eed94a" : blue ? "#42A5F5" : red ? "#f32643" : white ? '#ffffff' : "#E0E0E0"};
  }
  p{
    justify-content: center;
    margin: 0 auto;
    display: flex;
    position: relative;
    top: 4px;
  }
  @media(max-width:767px){
    width: 25px; 
    left: 50px;
    top:2px;
    height: 14.43px;
    margin: 7.22px 0;
    &::before,&:after{
      border-left: 12.5px solid transparent;
      border-right: 12.5px solid transparent;
    }
    &::before{
      bottom: 100%;
      border-bottom: 7.22px solid ${({ green, yellow,red,blue, white }) =>
      green ? "#22A122" : yellow ? "#eed94a" : blue ? "#42A5F5" : red ? "#f32643" : white ? '#ffffff' : "#E0E0E0"};
    }
    &::after{
      top: 100%;
      width: 0;
      border-top: 7.22px solid ${({ green, yellow,red,blue,white }) =>
      green ? "#22A122" : yellow ? "#eed94a" : blue ? "#42A5F5" : red ? "#f32643" : white ? '#ffffff' : "#E0E0E0"};
    }
    p{
      justify-content: center;
      margin: -3px auto;
      display: flex;
      position: relative;
      top: 2px;
      color: ${({ green, yellow,red,blue }) =>
      green ? "white" : yellow ? "white" : blue ? "white" : red ? "white" :  "black"};
      font-size:12px
    }
  }
`
const Hexagon = ({qNo,green,yellow,red,blue, white}) => (
  <HexagonWrapper green={green} yellow={yellow} red={red} blue={blue} white={white} >
    <p >{qNo}</p>
  </HexagonWrapper>
)
export default Hexagon;